import { ReactNode } from "react";
import classNames from "classnames";

type MemberlinkWrapperArgs = {
  url?: string;
  className?: string;
  title?: string;
  children: ReactNode;
};

export default function MemberlinkWrapper({
  url,
  className,
  title,
  children,
}: MemberlinkWrapperArgs) {
  return url ? (
    <a
      className={classNames("member-link", className)}
      href={url}
      title={title}
      aria-hidden
    >
      {children}
    </a>
  ) : (
    <span className={classNames("member-link", className)} title={title}>
      {children}
    </span>
  );
}
